import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 600px;
	padding: 30px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 6px 80px rgba(0, 0, 0, 0.5);
	border-radius: 10px;
`;

const StyledContent = styled.div<{ $img?: boolean }>`
	display: grid;
	grid-template-columns: ${(props) => (props.$img ? '200px 1fr' : '1fr')};
	gap: 20px;
	margin-top: 30px;
`;

export { StyledContainer, StyledContent };
